// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--22psY","heading":"styles-module--heading--3ReGs","bodyText":"styles-module--bodyText--1HvaD"};